import {
  podBase64,
  cocoBase64,
  zizziBase64,
  askBase64,
  azzurriBase64,
  justEatBase64,
  uberEatsBase64,
  deliverooBase64,
} from '../../../../assets/images/brand-logos';
import defaultLogo from '../../../../assets/images/brand-default.svg';

type Base64<imageType extends string> = `data:image/${imageType};base64${string}`;

export const brands: Record<string, Base64<'png'>> = {
  pod: podBase64,
  coco: cocoBase64,
  zizzi: zizziBase64,
  ask: askBase64,
  azzurri: azzurriBase64,
  just: justEatBase64,
  uber: uberEatsBase64,
  deliveroo: deliverooBase64,
};

const getDefaultLogo = (brandName: string) => {
  const name = brandName?.toLowerCase();

  const matchingBrand = Object.keys(brands).find((key: string) => name.includes(key));

  return matchingBrand ? brands[matchingBrand] : defaultLogo;
};

export default getDefaultLogo;
